import formatPrice from 'utils/formatPrice';

const getConvertedAmount = (amountToConvert, rate, toCurrency) =>
  formatPrice(Number.parseFloat(amountToConvert / rate), toCurrency);

export default getConvertedAmount;
